import React from 'react'
import { components } from 'cng-web-lib'
import { useParams } from 'react-router-dom'

import FormProperties from './FormProperties'
import { Grid } from '@material-ui/core'
import MGTTApiUrls from 'src/apiUrls/MGTTApiUrls'

const {
  form: { CngViewForm }
} = components

function ViewPage({ showNotification }) {
  const { id } = useParams()

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <CngViewForm
          fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
          showNotification={showNotification}
          bodySection={
            <FormProperties.Fields
              disabled={true}
              showNotification={showNotification}
            />
          }
          formikProps={FormProperties.formikProps}
          toClientDataFormat={FormProperties.toClientDataFormat}
          toServerDataFormat={FormProperties.toServerDataFormat}
          fetch={{
            id: id,
            url: MGTTApiUrls.GET_ADMIN_CONFIG
          }}
        />
      </Grid>
    </Grid>
  )
}

export default ViewPage
